export const camelToSnakeCase = (str: string) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)

export const camelToText = (str: string) =>
    capitalize(str).replace(/[A-Z]/g, (letter) => ` ${capitalize(letter.toLowerCase())}`)

export const snakeToCamelCase = (str: string) =>
    str.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export const isValidUrl = (url: unknown) => {
    try {
        return new URL(`${url as string}`)
    } catch (_) {
        return false
    }
}

export const rTrim = (str: string, char: string) => {
    if (str.endsWith(char)) {
        return str.slice(0, -1)
    } else {
        return str
    }
}

interface IObjectType {
    [k: string]: object
}

function includes(haystack: string[], needle: string) {
    return haystack.indexOf(needle) !== -1
}

export function pick(data: IObjectType, toPick: string[]) {
    return pickBy(data, toPick, (values, v) => includes(values, v))
}

export function omit(data: IObjectType, toOmit: string[]) {
    return pickBy(data, toOmit, (values, v) => !includes(values, v))
}
function pickBy(data: IObjectType, values: string[], predicate: (values: string[], v: string) => boolean) {
    return Object.keys(data).reduce((c: IObjectType, v) => {
        if (predicate(values, v)) {
            c[v] = data[v]
            return c
        }
        return c
    }, {})
}

export interface PricingItemsProps {
    priceWithVat: number
    priceWithoutVat: number
    vat: number
}
export const checkPricingCompatibility = (pricingItems: PricingItemsProps): boolean => {
    const { priceWithVat, priceWithoutVat, vat } = pricingItems

    return priceWithoutVat + vat === priceWithVat
}
